import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, CxDatePipe, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { PriceAgreementHistoryComponent } from './price-agreement-history.component'

@NgModule({
  declarations: [PriceAgreementHistoryComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule, MaterialModule],
  providers: [
    CxDatePipe,
    provideDefaultConfig({
      cmsComponents: {
        PriceSupportAgreementsComponent: {
          component: PriceAgreementHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class PriceAgreementHistoryModule {}
